import { EApiLanguageCode } from '@datatype/iyagigo/api-type';
/** @jsxImportSource @emotion/react */

import React from 'react';
import { useTypedSelector } from '@hook/common/useStore';
import ClassroomHome from '@component/iyagigo/classroom/classroom-home';
import PageTemplate from '@page/iyagigo/page-template';
import * as color from '@constant/color';
import Scroll from '@component/common/scroll';

const ClassroomHomePage: React.FC<any> = () => {
  // ############### state ###############
  const studyLanguage = useTypedSelector((state) => state.rootReducer?.studentReducer?.currentStudyLanguage) ?? null;

  // ############### variable ###############
  const HEADER_TITLE = studyLanguage === EApiLanguageCode.ENGLISH ? '영어 교실' : '일본어 교실';

  return (
    <PageTemplate title={HEADER_TITLE} mode={'page'} backgroundColor={color.GRAY_BACKGROUND_COLOR}>
      <Scroll direction='y' height={`calc(100% - 10px)`}>
        <ClassroomHome />
      </Scroll>
    </PageTemplate>
  );
};

export default ClassroomHomePage;
